module.exports = __webpack_public_path__ + "static/media/5.48f4ad1c.svg";